import React from 'react'

const Applinks = () => {
	return (
		<div className="mb-32 flex flex-col gap-20 bg-secondary px-8 py-16 md:grid md:grid-cols-2 md:px-32">
			<div className="space-y-14">
				<div className="flex flex-col gap-6 text-white">
					<img
						width={212}
						height={40}
						src="/img/notify-logo-white.svg"
						alt="Notify"
					/>
					<h2 className=" text-4xl font-semibold leading-[58px] lg:text-5xl lg:leading-[62px]">
						Vyzkoušejte sílu notifikací ještě dnes.
					</h2>
					<p>
						Vaší aplikaci si budou zákazníci moct do 14 dnů stáhnout odkudkoliv.
					</p>
				</div>
				<div className="hidden gap-4 md:flex">
					<img
						src="img/apple-store.webp"
						alt="apple-store"
						width={194}
						height={56}
					/>
					<img
						src="img/google-play.webp"
						alt="google-play"
						width={194}
						height={56}
					/>
				</div>
				<img
					src="img/apple-google.webp"
					alt="apple-google"
					className="md:hidden"
				/>
			</div>
			<div className="flex items-center justify-center">
				<img
					src="img/shop-notifications.webp"
					alt="shop-notifications"
					height={218}
					width={378}
				/>
			</div>
		</div>
	)
}

export default Applinks
